<template>
  <div>
  <div class="row">
        <div class="col-lg-12 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h2 class="card-title">CBR Vocal Chain</h2>
              <p class="category">*Cased-Based-Reasoning Approach to Vocal Audio Production*</p>
            </div>
            <div class="card-content">
              <img src="../../../../../static/img/vocal-chain-img.png" alt="A screenshot of Ableton Live" style="border-radius:30px;margin-bottom:20px">
              <p>This project was an effort to use case-based reasoning within vocal audio production in Ableton Live.  The mainfestation of this work resulted in a paper publication at ICCBR '23 alongside a vocal audio chain created in Max/MSP.</p>
            </div>
          </div>
        </div>
  </div>

  <!-- Demo Stuff -->
  <div class="row">
      <div class="col-lg-6 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">ICCBR '22 Presentation</h4>
            </div>
            <div class="card-content">
              <p>This was the presentation of my project that I gave at ICCBR '22 in Nancy, FR.  I promise the video wasn't just me sharing information in a slideshow.  There are some audio examples as well :) </p>
              <youtube :video-id="videoIdOne" ref="youtube" @playing="playing"></youtube>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Experiment Setup</h4>
            </div>
            <div class="card-content">
              <p>If you wanted a bit more insight into the experiment that was conducted, while reaching out to peeps for the pilot study, I sent this video to folks to may have been interested in this study.  Check it out if you're interested in understanding a bit more about the overall process.</p>
              <youtube :video-id="videoIdTwo" ref="youtube" @playing="playing"></youtube>
            </div>
          </div>
        </div>
    </div>

  </div>
</template>

<script>
import VueGallery from 'vue-gallery'

export default {
  data () {
    return {
      videoIdOne: 'KQPPfA4ERhE',
      videoIdTwo: 'R5aGSFmRYIE',
      index: null
    }
  },
  methods: {
    playVideo () {
      this.player.playVideo()
    },
    playing () {
      console.log('/\\o/ we are watching!!!')
    }
  },
  computed: {
    player () {
      return this.$refs.youtube.player
    }
  },
  components: {
    'gallery': VueGallery
  }
}
</script>
<style>
iframe {
  width: 100%;
  max-width: 650px; /* Also helpful. Optional. */
}
.image {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border: 1px solid #ebebeb;
    margin: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Projects/CBRVocalChain.vue